module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-MediumItalic.bc8845c2.woff";